import {Component} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';

import {AdminTopbarComponent} from "../components/admin/admin-topbar/admin-topbar.component";
import {AdminSidebarComponent} from "../components/admin/admin-sidebar/admin-sidebar.component";
import {RouterOutlet} from "@angular/router";
import {FooterComponent} from "../components/common/footer/footer.component";
import {BackToTopComponent} from "../components/common/back-to-top/back-to-top.component";

@Component({
    selector: 'app-admin',
    imports: [
    AdminTopbarComponent,
    AdminSidebarComponent,
    RouterOutlet,
    BackToTopComponent,
    FooterComponent
],
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.css']
})
export class AdminComponent {

  constructor(private keycloakService: KeycloakService) {
  }

  logout(): void {
    this.keycloakService.logout();
  }

  // This is a bit hacky-ish... but we don't use font-awesome library directly so...
}
